import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { take } from 'rxjs';
import { EdgeDevice, EdgeDeviceService } from 'services/edge-device/edge-device.service';

@Component({
  selector: 'ems-edge-device-select',
  templateUrl: './edge-device-select.component.html',
  styleUrls: ['./edge-device-select.component.scss']
})
export class EdgeDeviceSelectComponent implements OnInit {

  private edgeDevices: Array<EdgeDevice> = []
  private _initialEdgeId: string | null = null

  public edgeDevice: EdgeDevice = {
    edgeId: '',
    label: ''
  }

  @Input() set initialEdgeId(id: string) {
    this._initialEdgeId = id
    this.applyInitialSelection()
  }

  @Output() public edgeDeviceSelected: EventEmitter<EdgeDevice> = new EventEmitter<EdgeDevice>();


  public get EdgeDevices(): Array<EdgeDevice> {
    return this.edgeDevices
  }

  onSelectionChanged(event: any) {
    console.log('Selection changed!', event.value);           // the new selected value
    console.log('Source:', event.source);                     // the MatSelect instance
    this.edgeDevice = event.value
    this.edgeDeviceSelected.emit(event.value);
  }

  constructor(
    private edgeDeviceService: EdgeDeviceService,
  ) {
  }

  ngOnInit(): void {
    this.fetchEdgeDevices()
  }

  private fetchEdgeDevices(): void {
    this.edgeDeviceService.list().pipe(
      take(1)
    ).subscribe((devices) => {
      this.edgeDevices = devices
      if (Array.isArray(devices) && devices.length > 0) {
        const result = this.applyInitialSelection()
        if (!result) {
          this.edgeDevice = devices[0]
          this.edgeDeviceSelected.emit(this.edgeDevice)
        }
      }
    })
  }

  private applyInitialSelection(): boolean {
    if (!this._initialEdgeId || !this.edgeDevices.length) return false
    const match = this.edgeDevices.find(d => d.edgeId === this._initialEdgeId)
    if (!match) return false
    this.edgeDevice = match
    this.edgeDeviceSelected.emit(match)
    return true
  }

}
